document.addEventListener("DOMContentLoaded", function () {
    const playButton = document.querySelector(".custome-play-button");
    const videoPlaceholder = document.querySelector(".video-place-holder"); // Target the video element
    const modal = document.getElementById("videoModal");
    const closeModal = document.querySelector(".close-video-modal");
    const videoPlayerContainer = document.getElementById("videoPlayerContainer");

    function openModal(videoUrl) {
        videoPlayerContainer.innerHTML = ''; // Clear previous video

        let videoElement;

        if (videoUrl.includes("youtube.com") || videoUrl.includes("youtu.be")) {
            // Extract YouTube video ID
            let videoId = videoUrl.split("v=")[1] || videoUrl.split("/").pop();
            videoId = videoId.split("&")[0]; // Remove extra parameters

            videoElement = document.createElement("iframe");
            videoElement.src = `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`;
            videoElement.allow = "autoplay; encrypted-media";
            videoElement.allowFullscreen = true;
        } else {
            // For normal video files
            videoElement = document.createElement("video");
            videoElement.src = videoUrl;
            videoElement.controls = true;
            videoElement.autoplay = true;
        }

        videoElement.style.width = "100%";
        videoElement.style.height = "100%";
        videoPlayerContainer.appendChild(videoElement);

        modal.style.display = "flex";
        document.body.classList.add("modal-open"); // Prevent scrolling
    }

    function handleOpenModal() {
        const videoUrl = playButton.getAttribute("data-video-url");
        openModal(videoUrl);
    }

    // Open modal when clicking on the play button
    playButton.addEventListener("click", handleOpenModal);

    // Open modal when clicking on the placeholder video
    videoPlaceholder.addEventListener("click", handleOpenModal);

    // Close modal
    function closeModalFunction() {
        modal.style.display = "none";
        videoPlayerContainer.innerHTML = ''; // Stop video
        document.body.classList.remove("modal-open"); // Allow scrolling again
    }

    closeModal.addEventListener("click", closeModalFunction);

    window.addEventListener("click", function (event) {
        if (event.target === modal) {
            closeModalFunction();
        }
    });
});